import { DocumentTypes } from "../../DocumentTypes";
import { DocumentSelectorProps } from "./InputProps";

import "./DocumentSelector.scss";

const DocumentSelector: React.FC<DocumentSelectorProps> = ({
    currentDocument,
    setCurrentDocument,
    documentTypeSelectorRef,
}) => {
    const handleSelectDocumentType = (documentId: string): void => {
        const currentDocument = DocumentTypes.find((doc) => doc.id === documentId);
        setCurrentDocument(currentDocument ? currentDocument : null);
    };

    const renderDocumentTypeOptions = () => {
        return DocumentTypes.map((documentType) => {
            return (
                <option key={documentType.id} value={documentType.id}>
                    {documentType.optionTitle}
                </option>
            );
        });
    };

    return (
        <div className="document-selector">
            <label htmlFor="document-type-select">Document Type</label>
            <select
                id="document-type-select"
                value={currentDocument ? currentDocument.id : "-1"}
                ref={documentTypeSelectorRef}
                onChange={(event) => handleSelectDocumentType(event.target.value)}
            >
                <option value="-1">Select a Document Type</option>
                {renderDocumentTypeOptions()}
            </select>
        </div>
    );
};

export default DocumentSelector;
